import { authApiCall } from '../../auth/saga';

export const upgradeMembershipPlan = (mem_id, start_trial) =>
  authApiCall({
    url: '/subscription/upgrade-plan/',
    method: 'post',
    data: {mem_id, start_trial},
  });
